import type React from 'react';

import { create } from 'zustand';

type DetailsDrawerState = {
  isDrawerOpen: boolean;
  drawerContent: React.ReactNode | null;
  openDrawer: (content: React.ReactNode) => void;
  closeDrawer: () => void;
  drawerTitle: string;
  setDrawerTitle: (title?: string) => void;
  entityId: string;
  setEntityId: (entityId: string) => void;
};

const useDetailsDrawerStore = create<DetailsDrawerState>((set) => ({
  isDrawerOpen: false,
  drawerContent: null,
  drawerTitle: '',
  setDrawerTitle: (drawerTitle?: string) => set({ drawerTitle }),
  openDrawer: (content: React.ReactNode) =>
    set({ isDrawerOpen: true, drawerContent: content }),
  closeDrawer: () => set({ isDrawerOpen: false, drawerContent: null }),
  entityId: '',
  setEntityId: (entityId: string) => set({ entityId })
}));

export { useDetailsDrawerStore };
